import React from 'react'
import CounselorForgotPasswordLayer from './CounselorForgotPasswordLayer';

const CounselorForgotPasswordPage = () => {
  return (
    <>
      {/* ForgotPasswordLayer */}
      <CounselorForgotPasswordLayer />
    </>
  );
}

export default CounselorForgotPasswordPage